import React from 'react';
import GraphBar from '../GraphBar';

import styles from './Graph.module.css';

interface GraphProps { }

const Graph = (props: GraphProps) => {
  return (
    <div className={styles.graph}>
      <GraphBar value={17.45} max={52.36} label={'mon'} />
      <GraphBar value={34.91} max={52.36} label={'tue'} />
      <GraphBar value={52.36} max={52.36} label={'wed'} />
      <GraphBar value={31.07} max={52.36} label={'thu'} />
      <GraphBar value={23.39} max={52.36} label={'fri'} />
      <GraphBar value={43.26} max={52.36} label={'sat'} />
      <GraphBar value={25.48} max={52.36} label={'sun'} />
    </div>
  );
};

export default Graph;